<snl-modal class="add-ship-model" *ngIf="iNewShipForm" [ngClass]="{ 'subpool-col':tab =='all' }" (modalClose)="iNewShipForm = false" [type]="'medium'" [open]="iNewShipForm" [settings]="setting">
    <div slot="heading">Add Ship(s)</div>
      <div slot="modalContent" (click)="closeSearchShip()">
        <div class="add-ship-box" cdkDropListGroup>
             <div class="ship-filter-box">
                <div class="ship-action">
                  <div class="select"> 
                    <span class="form">Ships from IMOS (new)</span>
                  </div> 
                  <div class="search addshipsearch"> 
                    <app-search-input  *ngIf="viewModel.shipsData.length > 0 && viewModel.searchInput" (click) ="$event.stopPropagation()"
                      [label]="'Search ship name / code'"
                      [data]="viewModel.shipsData"
                      disabled="true"
                      [searchText] = 'viewModel.searchText'
                      (searchValue) = "valuechange($event)"
                  ></app-search-input>
                  </div> 
                </div>
                <div class="ship-filter-list">
                  <div class="drag-drop-list" cdkDropList [cdkDropListData]="viewModel.selectdShip" (cdkDropListDropped)="drop($event,'ship');multiSelect.dropListDropped($event)">
                    <div class="ship-box draggable-bx body-b1 " [ngClass]="{'selected':shipFormTempSelected(item) }" *ngFor="let item of viewModel.selectdShip"
                      cdkDrag
                      (pointerdown)="multiSelect.mouseDown($event)"
                      (cdkDragStarted)="multiSelect.dragStarted();multiDrag.dragStarted($event,viewModel.shipsFromDragListTemp,viewModel.shipsFromdragListCopyTemp)"
                      (cdkDragEnded)="multiSelect.dragEnded()"
                    >
                    <div  class="body-b1 text-icon data-text">
                      <span class="text d-flex">
                        <span class="d-flex container-c-bx">
                          <snl-checkbox [checked]="shipFormTempSelected(item)"  (onClick)="checkTempShip(item)"></snl-checkbox>
                          <span class="ShipsPillsMain CommonPillsMain color__primary cursor-all-scroll"> 
                            {{getShipDetails(item) | titlecase}}
                            <span class="ShipNumberPills CommonPills fw-400"> {{item}} </span>
                          </span>
                        </span>
                       </span>
                      </div>
                     </div>
                  </div>
                </div>
              </div>

              <div class="dragdrop df-c">
                <span class="dragtext df-c" (click)="moveShip()">
                  <span>Drag & drop the desired ships or select and push them.</span>
                  <svg width="33" height="27" viewBox="0 0 33 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.9993 1.83325L11.3529 1.4797L10.9993 1.12614L10.6458 1.4797L10.9993 1.83325ZM4.93624 8.60347L11.3529 2.18681L10.6458 1.4797L4.22913 7.89636L4.93624 8.60347ZM10.6458 2.18681L17.0625 8.60347L17.7696 7.89637L11.3529 1.4797L10.6458 2.18681ZM10.4993 1.83325L10.4993 20.1666L11.4993 20.1666L11.4993 1.83325L10.4993 1.83325Z" fill="black"/>
                    <path d="M21.9993 25.1666L21.6458 25.5201L21.9993 25.8737L22.3529 25.5201L21.9993 25.1666ZM28.0625 18.3964L21.6458 24.813L22.3529 25.5201L28.7696 19.1035L28.0625 18.3964ZM22.3529 24.813L15.9362 18.3964L15.2291 19.1035L21.6458 25.5201L22.3529 24.813ZM22.4993 25.1666L22.4993 6.83325L21.4993 6.83325L21.4993 25.1666L22.4993 25.1666Z" fill="black"/>
                  </svg>                     
                </span>
              </div>

              <div class="ship-filter-box ship-form-box">
                <div class="ship-action">
                  <span class="form">
                    Add to 
                    <ng-container *ngIf="viewModel.fleet == 'STJS'" >
                      Sub Pool
                    </ng-container>
                  
                    <span *ngIf="tab !='all'">{{tab}}</span></span>
                </div>
                <div class="ship-form-list">
                  <div  class="drag-drop-list" cdkDropList [cdkDropListData]="viewModel.addShipList" (cdkDropListDropped)="drop($event,'addShip');multiSelect.dropListDropped($event)">
                    <form [formGroup]="ShipForm">
                      <snl-table *ngIf="viewModel.addShipList.length > 0" class="addShipTable" [ngClass]="{ 'LastRowDropdown':viewModel.addShipList.length > 2 }">
                        <snl-row>
                          <snl-th class="shipname"><span>Ship Name/ Code</span></snl-th>
                          <snl-th class="subpool" *ngIf="tab =='all'"><span>Sub Pool</span></snl-th>
                          <snl-th class="class"><span>Class</span></snl-th>
                          <snl-th class="owner"><span>Ship Owner</span></snl-th>
                          <snl-th class="pool-point"><span>Pool Point</span></snl-th>
                          <snl-th class="effectiveForm"><span>Effective From</span></snl-th> 
                        </snl-row>
                        <ng-container formArrayName="ships">
                          <snl-row [formGroupName]="i" *ngFor="let shipForm of shipFormGroups.controls; let i=index">
                              <snl-td>
                                <span class="text d-flex">
                                  <span class="d-flex container-c-bx">
                                    <span class="ShipsPillsMain CommonPillsMain color__primary d-flex"> 
                                      <span class="truncate-txt single-line ship-name">{{shipForm.value.vslName}}</span>
                                      <span class="ShipNumberPills CommonPills fw-400"> {{shipForm.value.vslNumber}} </span>
                                    </span>
                                  </span>
                                </span>
                              </snl-td>
                              <snl-td class="CustomizeInput dropdown-customize" *ngIf="tab =='all'">
                                <ng-select class="btm-border-select" [items]="subpool" [searchable]="false" formControlName="subPool"
                                  [ngClass]="{ 'is-invalid':(viewModel.addShipSubmit && getReferralsFormArr(i).controls['subPool'].hasError('required')) || (getReferralsFormArr(i).controls['subPool'].touched && (getReferralsFormArr(i).controls['subPool'].hasError('required'))) }"
                                  > 
                                  <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                    let-index="index">  
                                    <span [innerHTML]="item"></span>
                                  </ng-template> 
                                </ng-select>
                              </snl-td>
                              <snl-td class="NameOfClss">
                                <span class="truncate-txt single-line color__primary">{{shipForm.value.vslClass}}</span>
                              </snl-td>
                              <snl-td class="CustomizeInput dropdown-customize">
                                <ng-select class="btm-border-select" [items]="viewModel.owners" [searchable]="false"
                                  formControlName="vslOwner"
                                  [ngClass]="{ 'is-invalid':(viewModel.addShipSubmit && getReferralsFormArr(i).controls['vslOwner'].hasError('required')) || (getReferralsFormArr(i).controls['vslOwner'].touched && (getReferralsFormArr(i).controls['vslOwner'].hasError('required'))) }"
                                > 
                                  <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                    let-index="index">  
                                    <span [innerHTML]="item.label"></span>
                                  </ng-template> 
                                </ng-select>
                              </snl-td>
                             <snl-td class="CustomizeInput">
                              <snl-input  formControlName="poolPoint" label="" placeholder=""   value="" [isError]="(getReferralsFormArr(i).controls['poolPoint'].hasError('required') && viewModel.addShipSubmit ) || getReferralsFormArr(i).controls['poolPoint'].touched && (getReferralsFormArr(i).controls['poolPoint'].hasError('required') || getReferralsFormArr(i).controls['poolPoint'].hasError('pattern'))"></snl-input>
                            </snl-td>
                            <snl-td class="CustomizeInput position_relative">
                              <snl-input class="datepicker df-c" snlDatePicker [min]="viewModel.minDate" (selectedDate) = selectedDate($event,i) placeholder="" label="" [value]="getReferralsFormArr(i).controls['effectiveForm'].value" formControlName="effectiveForm"  [isError]="(getReferralsFormArr(i).controls['effectiveForm'].hasError('required') && viewModel.addShipSubmit ) || getReferralsFormArr(i).controls['effectiveForm'].touched && (getReferralsFormArr(i).controls['effectiveForm'].hasError('required'))"  [isTrailingIconDisplayed]="true" trailingIcon="fa-calendar far"></snl-input>
                              <div class="clear-row-main df-c"> 
                                <svg (click)="deleteShip(i,shipForm.value.vslNumber)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12.75 11.7188C13.0312 12.0312 13.0312 12.5 12.75 12.7812C12.4375 13.0938 11.9688 13.0938 11.6875 12.7812L8 9.0625L4.28125 12.7812C3.96875 13.0938 3.5 13.0938 3.21875 12.7812C2.90625 12.5 2.90625 12.0312 3.21875 11.7188L6.9375 8L3.21875 4.28125C2.90625 3.96875 2.90625 3.5 3.21875 3.21875C3.5 2.90625 3.96875 2.90625 4.25 3.21875L8 6.96875L11.7188 3.25C12 2.9375 12.4688 2.9375 12.75 3.25C13.0625 3.53125 13.0625 4 12.75 4.3125L9.03125 8L12.75 11.7188Z" fill="#788496"/>
                                </svg>  
                              </div>
                            </snl-td> 
                          </snl-row>
                        </ng-container>
                      </snl-table>
                    </form>  
                   
                    </div>
                </div>
              </div>
             
        </div>
       
      </div>
    <div slot="modalFooter">
      <snl-button size="small" (buttonClick)="saveShip()" [disabled]="!viewModel.addShipList.length">Save</snl-button>
      <snl-button size="small" type="secondary" (buttonClick)="close()">Cancel</snl-button>
    </div>
  </snl-modal>